import "./small_hero.css";
